import { render, staticRenderFns } from "./FavoritesBar.vue?vue&type=template&id=8ea980c6&lang=pug&"
import script from "./FavoritesBar.vue?vue&type=script&lang=js&"
export * from "./FavoritesBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports